import { render } from "./AyudaAnatAten.vue?vue&type=template&id=44a206cc&scoped=true"
import script from "./AyudaAnatAten.vue?vue&type=script&lang=js"
export * from "./AyudaAnatAten.vue?vue&type=script&lang=js"

import "@/assets/css/ayuda.css?vue&type=style&index=0&id=44a206cc&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44a206cc"]])

export default __exports__